import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CategoryManager from './CategoryManager';
import randomInt from "../utils/randomInt";
import ProductFocuses from "../routes/ProductFocuses";
import ProductFocusesManager from "./ProductFocusesManager";
import ProductFocusGroupContentManager from "./ProductFocusGroupContentManager";

class ProductFocusesStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.PRODUCT_FOCUSES_FETCH:
        ProductFocusesManager.fetch();
        return this.getInitialState();

      case ActionTypes.PRODUCT_FOCUSES_FETCH_COMPLETED:
        return action.productFocuses;

      case ActionTypes.PRODUCT_FOCUS_VIEWED:
        ProductFocusesManager.saveActivity({
          entity_id: action.id,
          event_type: 'product_focus_viewed'
        });
        return state;

      case ActionTypes.PRODUCT_FOCUS_VIEWED_COMPLETED:
        return action.productFocus;

      default:
        return state;
    }
  }

}

export default new ProductFocusesStore();
